import api from '@/store/api/number/myriad2'
import * as mutationTypes from './mutation-types'
import { handleApiCall } from '@/store/utils'

const initialState = () => ({
    number: {},
    barredNumbers: []
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        number: state => state.number,
        barredNumbers: state => state.barredNumbers
    },
    actions: {
        showNumber: ({ commit, dispatch }, data) => handleApiCall({ commit, dispatch }, api.show, data, mutationTypes.SET_NUMBER),
        cancelNumber: ({ dispatch }, data) => handleApiCall({ dispatch }, api.cancel, data),
        uncancelNumber: ({ dispatch }, data) => handleApiCall({ dispatch }, api.uncancel, data),
        suspendNumber: ({ dispatch }, data) => handleApiCall({ dispatch }, api.suspend, data),
        unsuspendNumber: ({ dispatch }, data) => handleApiCall({ dispatch }, api.unsuspend, data),
        aliasNumberPlan: ({ dispatch }, data) => handleApiCall({ dispatch }, api.aliasPlan, data),
        faxToEmail: ({ dispatch }, data) => handleApiCall({ dispatch }, api.faxToEmail, data),
        cloneNumber: ({ dispatch }, data) => handleApiCall({ dispatch }, api.clone, data),
        removePlan: ({ dispatch }, data) => handleApiCall({ dispatch }, api.removePlan, data),
        listBarredNumbers: ({ commit, dispatch }, data) => handleApiCall({ commit, dispatch }, api.listBarredNumbers, data, mutationTypes.SET_BARRED_NUMBERS),
        barNumbers: ({ dispatch }, data) => handleApiCall({ dispatch }, api.barNumbers, data),
        unbarNumbers: ({ dispatch }, data) => handleApiCall({ dispatch }, api.unbarNumbers, data),
        resetNumber: ({ commit }) => commit(mutationTypes.RESET_NUMBER),
        resetBarredNumbers: ({ commit }) => commit(mutationTypes.RESET_BARRED_NUMBERS)
    },
    mutations: {
        [mutationTypes.SET_BARRED_NUMBERS]: (state, data) => state.barredNumbers = data,
        [mutationTypes.RESET_BARRED_NUMBERS]: (state) => state.barredNumbers = initialState().barredNumbers,
        [mutationTypes.SET_NUMBER]: (state, data) => state.number = data,
        [mutationTypes.RESET_NUMBER]: (state) => Object.assign(state, initialState())
    }
}
